var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('notif-container'),_c('transition',{attrs:{"mode":"out-in","enter-active-class":"animate__animated animate__fadeIn  animate__faster","leave-active-class":"animate__animated animate__fadeOut  animate__faster"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }